var GroupService = /** @class */ (function () {
    function GroupService(api) {
        this.API = api;
    }
    GroupService.prototype.listGroups = function (query, showAppGroups, organizationId) {
        var url = "/groups?";
        if (query) {
            url += query;
        }
        if (!showAppGroups) {
            if (organizationId)
                url += "type=organization&organization=".concat(organizationId);
            else
                url += "type=organization&";
        }
        return this.API.get(url);
    };
    GroupService.prototype.updateGroups = function (data) {
        var url = "/groups/update/hidden";
        return this.API.put(url, data);
    };
    GroupService.prototype.listAppGroups = function (appId, query) {
        var url = "/groups?app=".concat(appId, "&type=app");
        if (query) {
            url += query;
        }
        return this.API.get(url);
    };
    GroupService.prototype.listAppAdminGroups = function (appId, query) {
        var url = "/groups?app=".concat(appId, "&type=appadmin");
        if (query) {
            url += query;
        }
        return this.API.get(url);
    };
    GroupService.prototype.createGroup = function (data) {
        var url = "/groups";
        data.type = 'organization';
        if (data.app) {
            data.type = 'app';
        }
        return this.API.post(url, data);
    };
    GroupService.prototype.createAppAdminGroup = function (data) {
        var url = "/groups";
        data.type = 'organization';
        if (data.app) {
            data.type = 'appadmin';
        }
        return this.API.post(url, data);
    };
    GroupService.prototype.getGroup = function (groupId) {
        var url = "/groups/".concat(groupId);
        return this.API.get(url);
    };
    GroupService.prototype.getGroupMembers = function (groupId) {
        var url = "/groups/".concat(groupId, "/members");
        return this.API.get(url);
    };
    GroupService.prototype.addUsersToGroup = function (groupId, userIds) {
        var url = "/groups/".concat(groupId, "/assign");
        var data = {
            ids: userIds,
        };
        return this.API.post(url, data);
    };
    GroupService.prototype.removeUsersFromGroup = function (groupId, userIds) {
        var url = "/groups/".concat(groupId, "/remove");
        var data = {
            ids: userIds,
        };
        return this.API.post(url, data);
    };
    GroupService.prototype.deleteGroup = function (groupId) {
        var url = "/groups/".concat(groupId);
        return this.API.delete(url);
    };
    return GroupService;
}());
export { GroupService };
